
import { Card, Button, Progress } from "@nextui-org/react";
import { useCallback, useState, useEffect } from "react";
import useW3NFTMachine from "../../../hooks/useW3NFTMachine.js";
import { formatAmount } from "../../../utils/amount";
import { formatUnits } from "viem";
import { NumberCount } from "../../../components/NumberCount";

const NFTMachine = ({ _index }) => {
    const [claiming, setClaiming] = useState(false)
    // console.log('_index', _index);
    const {value ,withdrawDividend ,loading} = useW3NFTMachine(_index);
    // console.log('=====', value);
    return value && (
        <Card className="bg-gray-100 dark:bg-box p-6 rounded-xl shadow-xl mt-4" style={{ boxShadow: "inset 0 3px 3px rgba(0, 0, 0, 0.5)" }}>
          <div className="flex-row gap-4 items-center">
            <img
              src="/images/nft.png"
              alt="股东 NFT 卡牌"
              className="w-full h-18 object-cover rounded-lg border border-yellow-600"
            />


          </div>

          <div className="flex gap-2 pl-4 border border-button rounded-lg mt-2">
              <div className="flex-1 text-white-400 text-xs min-w-10 h-8 text-xs font-medium rounded-lg mt-4 ">
                分红USDT
              </div>
              <div className="flex-1  text-md min-w-10 h-8 text-md text-button font-medium rounded-lg mt-3">
                <NumberCount value={parseFloat(formatAmount(formatUnits(value.USDTDividend,18)))} decimals={3}/>
              </div>
              <div className="flex-1 text-gray-400 text-xs min-w-10 h-8 text-md  font-medium rounded-lg m-auto">
                <Button className="bg-button text-black min-w-10 h-8 text-xs font-medium rounded-lg" onPress={withdrawDividend} disabled={loading} isLoading={loading}>
                  领取
                </Button>
              </div>

              </div>
        </Card>
    )
}
export default NFTMachine;